import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function ServiceCards() {
  const { t } = useTranslation();

  const categoryTitles: Record<string, string> = {
    'short-video': t('categoryShortVideo'),
    'brand-marketing': t('categoryBrandMarketing'),
    'ad-planning': t('categoryAdPlanning'),
    'social-media': t('categorySocialMedia'),
    'content-creative': t('categoryContentCreative'),
    'full-service': t('categoryFullService'),
  };

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">{t('serviceTitle')}</h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">{t('serviceDesc')}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-lg mb-5 ${
                  cat.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                  cat.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                  'bg-secondary-100 text-secondary-600'
                }`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {categoryTitles[cat.slug] || cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">{cat.description}</p>
                <div className="flex items-center gap-1 text-sm text-primary-600 font-medium">
                  <span>{cat.articleCount} 篇内容</span>
                  <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}